import { colors } from '../../colors';
var address = {
  arrowColor: colors.brickOrange,
  textColor: colors.smoke,
  borderColor: colors.smoke,
  backgroundColor: colors.eggShell
};
export default address;